/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type TripGeojsonQRQueryVariables = {
    nodeId: string;
};
export type TripGeojsonQRQueryResponse = {
    readonly node: {
        readonly routeData?: {
            readonly freshTripGeojson: string | null;
        };
    } | null;
};
export type TripGeojsonQRQuery = {
    readonly response: TripGeojsonQRQueryResponse;
    readonly variables: TripGeojsonQRQueryVariables;
};



/*
query TripGeojsonQRQuery(
  $nodeId: ID!
) {
  node(id: $nodeId) {
    __typename
    ... on TripNode {
      routeData {
        freshTripGeojson
      }
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nodeId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "nodeId"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RouteDataObject",
      "kind": "LinkedField",
      "name": "routeData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "freshTripGeojson",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TripNode",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TripGeojsonQRQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TripGeojsonQRQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "71d41f03e38228976d914646cdd8618d",
    "id": null,
    "metadata": {},
    "name": "TripGeojsonQRQuery",
    "operationKind": "query",
    "text": "query TripGeojsonQRQuery(\n  $nodeId: ID!\n) {\n  node(id: $nodeId) {\n    __typename\n    ... on TripNode {\n      routeData {\n        freshTripGeojson\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '28baad7930071d84bc3fdf155370071d';
export default node;
